export const inIframe = () => {
  return (
    typeof window !== "undefined" && window.location !== window.top?.location
  );
};
